import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

interface UserData {
  userData?: GetUserByToken;
  companySelect?: CompanySelect;
  accountingFirmSelect?: AccountingFirmSelect;
  companyData?: CompaniesWithAccountingFirm;
  resetStore: () => void;
  resetCompanySelect: () => void;
  setUserData: (userData: GetUserByToken) => void;
  setCompanySelect: (companySelect?: CompanySelect) => void;
  setAccountingFirmSelect: (accountingFirmSelect?: AccountingFirmSelect) => void;
  setCompanyData: (companyData?: CompaniesWithAccountingFirm) => void;
}

const initialState = {
  companySelect: undefined,
  accountingFirmSelect: undefined,
  companyData: undefined,
  userData: undefined,
};

const useUserDataStore: UseBoundStore<StoreApi<UserData>> = createStore<UserData>(
  (set: (fn: (draft: UserData) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(() => ({
        ...initialState,
      }));
    },
    resetCompanySelect: () => {
      set(() => ({
        companySelect: initialState.companySelect,
        accountingFirmSelect: initialState.accountingFirmSelect,
        companyData: initialState.companyData,
      }));
    },
    setUserData: (userData: GetUserByToken) => {
      setStateHelper("userData", userData, set);
    },
    setCompanySelect: (companySelect?: CompanySelect) => {
      setStateHelper("companySelect", companySelect, set);
    },
    setAccountingFirmSelect: (accountingFirmSelect?: AccountingFirmSelect) => {
      setStateHelper("accountingFirmSelect", accountingFirmSelect, set);
    },
    setCompanyData: (companyData?: CompaniesWithAccountingFirm) => {
      setStateHelper("companyData", companyData, set);
    },
  }),
);

export default useUserDataStore;
